import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class MissionAnimation {
	constructor() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			this.init(e.target);
		});
	}

	init(element) {
		const barsElements = element.querySelectorAll('[data-mission-bars]');

		if (!barsElements.length) {
			return;
		}

		this.mm = gsap.matchMedia();

		this.mm .add({
			isMobile: `(max-width: 991px)`,
			isDesktop: `(min-width: 992px)`,
			reduceMotion: '(prefers-reduced-motion: reduce)',
		}, (context) => {
			this.context = context;

			if(this.context.conditions.isDesktop) {

				barsElements.forEach((bars) => this.createAnimation(bars));

			}
		});
	}

	createAnimation(element) {
		const bars = element.querySelectorAll('[data-mission-bar]');

		if (!bars.length) {
			return;
		}

		const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		if (mediaQuery.matches) {
			return;
		}

		const mainTimeline = gsap.timeline({
			scrollTrigger: element,
			delay: 0.2,
		});

		Array.from(bars)
			.reverse()
			.forEach((bar, index) => {
				const bg = bar.querySelector('[data-mission-bar-bg]');
				const text = bar.querySelector('[data-mission-bar-text]');

				let tl = gsap
					.timeline()
					.fromTo(bg, { scaleY: 0 }, { scaleY: 1, duration: 1.2, ease: 'power2.inOut' })
					.fromTo(text, { opacity: 0 }, { opacity: 1, duration: 1.4 }, '-=0.1');

				mainTimeline.add(tl, index * 0.6);
			});
	}

	destroy() {
		this.mm.kill();
	}
}
